import { AiOutlineExclamationCircle } from "react-icons/ai";
export const orderReminder = [
  {
    icon: AiOutlineExclamationCircle,
    content: "不設退款",
  },
  {
    icon: AiOutlineExclamationCircle,
    content: "入住時必需出示有效通行證或護照辦理入住手續。",
  },
  {
    icon: AiOutlineExclamationCircle,
    content: "酒店不接受添加或修改入住人姓名。",
  },
  {
    icon: AiOutlineExclamationCircle,
    content: "所有殘障客房之要求，必須在訂房時預先與酒店訂房部提出，並要經酒店確認後方可保留此類客房。",
  },
  {
    icon: AiOutlineExclamationCircle,
    content: "未經確認或客人抵店時才提出要求, 均不獲酒店安排。",
  },
  {
    icon: AiOutlineExclamationCircle,
    content: "所有已過最晚修改取消時間的訂單不接受任何更改，包括入住日期及姓名。",
  },
  {
    icon: AiOutlineExclamationCircle,
    content: "床型1張雙人床或2張床視供應情況安排，如您預訂此房型，酒店或未能滿足您的床型需求。",
  },
];
